import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './ToolTip.css'

const options = {
  allowMultiple: true
}
@CSSModules(styles, options)

export default class ToolTip extends Component {
  static propTypes = {
    title: PropTypes.string,
    isVisible: PropTypes.bool,
  }
  constructor (props) {
    super(props)
  }
  render () {
    return (
      <div styleName={`wrapper ${this.props.isVisible ? 'isVisible' : ''}`} dangerouslySetInnerHTML={{ __html: this.props.title }} />
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/ToolTip/ToolTip.js